<div class="error-wrapper">
  <img src="../../../assets/permission-denied.png" alt="Access Denied" class="error-image">
  <h2 class="error-title">Sorry, you cannot view the page.</h2>
  <p class="error-subtitle">No permission to access this page.</p>
  <p class="error-text">To access, please contact the administrator.</p>
  <a routerLink="/" class="home-btn">Back to Home</a>
</div>
